import React from 'react';
import styled from 'styled-components';

import { Location } from '../../interfaces';
import { CrewJsonNode } from '../../interfaces/CrewJsonNode';
import { NodeCrew } from '../../interfaces/NodeCrew';
import { QueryResponseAllCrewJson } from '../../interfaces/QueryResponseAllCrewJson';
import { allCrewJson } from '../../queries/AllCrewJson';
import { getJsonByPathname } from '../../utils/GetJsonByPathname';
import { theme } from '../../utils/Theme';
import Headline from '../headline/Headline';
import CrewMember from '../CrewMember';

const Members = styled.div`
  width: 900px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  ${theme.mediaQuerySizes.tablet} {
    width: 700px;
  }
  ${theme.mediaQuerySizes.phone} {
    width: 100%;
    grid-template-columns: 1fr;
  }
`;

const Crew = (props: Location) => {
  const data = allCrewJson();
  return (
    <>
      <Headline arrowColor="arrowPink" title="Doświadczona i kreatywna kadra"></Headline>
      <Members>
        {getJsonByPathname<CrewJsonNode, QueryResponseAllCrewJson>(
          data,
          props.location.pathname,
          'allCrewJson',
        )?.crew?.map((person: NodeCrew, i: number) => (
          <CrewMember
            key={i}
            name={person.name}
            position={person.position}
            image={person.image}
            location={props.location}
          ></CrewMember>
        ))}
      </Members>
    </>
  );
};

export default Crew;
